import { TranslationType } from 'src/types';

export const getLocalizedLangValue = (title: TranslationType, language: string): string => {
  if (title[language]) {
    return title[language];
  }
  if (title.en) {
    return title.en;
  }
  return title.pl;
};
